import React, { useState } from 'react';
import styles from './Header.module.scss';
import { ReactComponent as NotificationIcon } from 'new/components/icons/bell.svg';
import { NavAction } from 'new/components/header/Header';
import { Popover } from 'new/elements/Popover';
import { NotificationsDropdown } from 'new/components/NotificationsDropdown';
import { useNotifications } from 'new/hooks/adapters/useNotifications';
import { useSelector } from 'react-redux';
import { MAIN_ALL } from 'js/constants/notificationsTypes';

export const NotificationAction = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const { notifications: rawNotif } = useNotifications({ type: MAIN_ALL });
  const unreadCounter = useSelector((state: any) => state.notifications?.unreadCounter);

  const notifications = rawNotif.slice(0, 20);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <div className={styles.navBlock}>
        <NavAction title="Notifications" onClick={handleClick} Icon={NotificationIcon} />
        {!!unreadCounter ? (
          <div className={styles.badge}>{unreadCounter > 99 ? '99+' : unreadCounter}</div>
        ) : null}
      </div>
      <Popover
        open={open}
        PaperProps={{
          className: styles.popover,
          sx: {
            borderRadius: '12px',
          },
        }}
        sx={{
          maxWidth: '60%',
        }}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <NotificationsDropdown notifications={notifications} />
      </Popover>
    </>
  );
};
